export const ORDER_STATUS_NEW = 27;

// Всем ответственным по заявке
export const NOTIFICATION_TYPE_RESPONSIBLE_USERS = 221;
// Всем пользователям указанного подразделения
export const NOTIFICATION_TYPE_DIVISION_USERS = 222;
// На общую почту указанного подразделения
export const NOTIFICATION_TYPE_DIVISION_EMAIL = 223;
// Конкретному пользователю
export const NOTIFICATION_TYPE_SPECIFIED_USER = 224;

export const RESET_ERROR = 'orders/RESET_ERROR';

export const FETCH_ORDER_FIELDS = 'orders/FETCH_ORDER_FIELDS';
export const FETCH_ORDER_FIELDS_FAIL = 'orders/FETCH_ORDER_FIELDS_FAIL';
export const FETCH_ORDER_FIELDS_SUCCESS = 'orders/FETCH_ORDER_FIELDS_SUCCESS';

export const UPDATE_ORDER_FIELDS_STORE_SUCCESS = 'orders/UPDATE_ORDER_FIELDS_STORE_SUCCESS';

export const FETCH_ORDERS = 'orders/FETCH_ORDERS';
export const FETCH_ORDERS_FAIL = 'orders/FETCH_ORDERS_FAIL';
export const FETCH_ORDERS_SUCCESS = 'orders/FETCH_ORDERS_SUCCESS';
export const FETCH_ORDER = 'orders/FETCH_ORDER';
export const FETCH_ORDER_FAIL = 'orders/FETCH_ORDER_FAIL';
export const FETCH_ORDER_SUCCESS = 'orders/FETCH_ORDER_SUCCESS';
export const CREATE_ORDER = 'orders/CREATE_ORDER';
export const CREATE_ORDER_FAIL = 'orders/CREATE_ORDER_FAIL';
export const CREATE_ORDER_SUCCESS = 'orders/CREATE_ORDER_SUCCESS';
export const UPDATE_ORDER = 'orders/UPDATE_ORDER';
export const UPDATE_ORDER_FAIL = 'orders/UPDATE_ORDER_FAIL';
export const UPDATE_ORDER_SUCCESS = 'orders/UPDATE_ORDER_SUCCESS';
export const DELETE_ORDER = 'orders/DELETE_ORDER';
export const DELETE_ORDER_FAIL = 'orders/DELETE_ORDER_FAIL';
export const DELETE_ORDER_SUCCESS = 'orders/DELETE_ORDER_SUCCESS';

export const FETCH_ORDER_PHOTOS = 'orders/FETCH_ORDER_PHOTOS';
export const FETCH_ORDER_PHOTOS_FAIL = 'orders/FETCH_ORDER_PHOTOS_FAIL';
export const FETCH_ORDER_PHOTOS_SUCCESS = 'orders/FETCH_ORDER_PHOTOS_SUCCESS';
export const FETCH_ORDER_CLIENT_PHOTOS = 'orders/FETCH_ORDER_CLIENT_PHOTOS';
export const FETCH_ORDER_CLIENT_PHOTOS_FAIL = 'orders/FETCH_ORDER_CLIENT_PHOTOS_FAIL';
export const FETCH_ORDER_CLIENT_PHOTOS_SUCCESS = 'orders/FETCH_ORDER_CLIENT_PHOTOS_SUCCESS';
export const CLEAR_ORDER_PHOTOS = 'orders/CLEAR_ORDER_PHOTOS';
export const CLEAR_ORDER_CLIENT_PHOTOS = 'orders/CLEAR_ORDER_CLIENT_PHOTOS';
export const CREATE_ORDER_PHOTO = 'orders/CREATE_ORDER_PHOTO';
export const CREATE_ORDER_PHOTO_FAIL = 'orders/CREATE_ORDER_PHOTO_FAIL';
export const CREATE_ORDER_PHOTO_SUCCESS = 'orders/CREATE_ORDER_PHOTO_SUCCESS';
export const UPDATE_ORDER_PHOTO = 'orders/UPDATE_ORDER_PHOTO';
export const UPDATE_ORDER_PHOTO_FAIL = 'orders/UPDATE_ORDER_PHOTO_FAIL';
export const UPDATE_ORDER_PHOTO_SUCCESS = 'orders/UPDATE_ORDER_PHOTO_SUCCESS';
export const DELETE_ORDER_PHOTO = 'orders/DELETE_ORDER_PHOTO';
export const DELETE_ORDER_PHOTO_FAIL = 'orders/DELETE_ORDER_PHOTO_FAIL';
export const DELETE_ORDER_PHOTO_SUCCESS = 'orders/DELETE_ORDER_PHOTO_SUCCESS';
export const RESTORE_ORDER_PHOTO = 'orders/RESTORE_ORDER_PHOTO';
export const RESTORE_ORDER_PHOTO_FAIL = 'orders/RESTORE_ORDER_PHOTO_FAIL';
export const RESTORE_ORDER_PHOTO_SUCCESS = 'orders/RESTORE_ORDER_PHOTO_SUCCESS';
export const CREATE_ORDER_VIDEO = 'orders/CREATE_ORDER_VIDEO';
export const CREATE_ORDER_VIDEO_FAIL = 'orders/CREATE_ORDER_VIDEO_FAIL';
export const CREATE_ORDER_VIDEO_SUCCESS = 'orders/CREATE_ORDER_VIDEO_SUCCESS';

export const FETCH_ORDER_INSTRUCTION = 'orders/FETCH_ORDER_INSTRUCTION';
export const FETCH_ORDER_INSTRUCTION_FAIL = 'orders/FETCH_ORDER_INSTRUCTION_FAIL';
export const FETCH_ORDER_INSTRUCTION_SUCCESS = 'orders/FETCH_ORDER_INSTRUCTION_SUCCESS';
export const CLEAR_ORDER_INSTRUCTION = 'orders/CLEAR_ORDER_INSTRUCTION';

export const FETCH_ORDER_COMMENTS = 'orders/FETCH_ORDER_COMMENTS';
export const FETCH_ORDER_COMMENTS_FAIL = 'orders/FETCH_ORDER_COMMENTS_FAIL';
export const FETCH_ORDER_COMMENTS_SUCCESS = 'orders/FETCH_ORDER_COMMENTS_SUCCESS';
export const CREATE_ORDER_COMMENT = 'orders/CREATE_ORDER_COMMENT';
export const CREATE_ORDER_COMMENT_SUCCESS = 'orders/CREATE_ORDER_COMMENT_SUCCESS';
export const CREATE_ORDER_COMMENT_FAIL = 'orders/CREATE_ORDER_COMMENT_FAIL';
export const DELETE_ORDER_COMMENT = 'orders/DELETE_ORDER_COMMENT';
export const DELETE_ORDER_COMMENT_SUCCESS = 'orders/DELETE_ORDER_COMMENT_SUCCESS';
export const DELETE_ORDER_COMMENT_FAIL = 'orders/DELETE_ORDER_COMMENT_FAIL';

export const FETCH_ORDER_TEMPORARY_FILES = 'orders/FETCH_ORDER_TEMPORARY_FILES';
export const FETCH_ORDER_TEMPORARY_FILES_FAIL = 'orders/FETCH_ORDER_TEMPORARY_FILES_FAIL';
export const FETCH_ORDER_TEMPORARY_FILES_SUCCESS = 'orders/FETCH_ORDER_TEMPORARY_FILES_SUCCESS';
export const CLEAR_ORDER_TEMPORARY_FILES = 'orders/CLEAR_ORDER_TEMPORARY_FILES';
export const CREATE_ORDER_TEMPORARY_FILES = 'orders/CREATE_ORDER_TEMPORARY_FILES';
export const CREATE_ORDER_TEMPORARY_FILES_FAIL = 'orders/CREATE_ORDER_TEMPORARY_FILES_FAIL';
export const CREATE_ORDER_TEMPORARY_FILES_SUCCESS = 'orders/CREATE_ORDER_TEMPORARY_FILES_SUCCESS';

export const FETCH_CARMEN_STATUSES = 'orders/FETCH_CARMEN_STATUSES';
export const FETCH_CARMEN_STATUSES_FAIL = 'orders/FETCH_CARMEN_STATUSES_FAIL';
export const FETCH_CARMEN_STATUSES_SUCCESS = 'orders/FETCH_CARMEN_STATUSES_SUCCESS';

export const FETCH_ORDER_RESPONSIBLES_FAIL = 'orders/FETCH_ORDER_RESPONSIBLES_FAIL';
export const FETCH_ORDER_RESPONSIBLES_SUCCESS = 'orders/FETCH_ORDER_RESPONSIBLES_SUCCESS';
export const CREATE_ORDER_RESPONSIBLES_FAIL = 'orders/CREATE_ORDER_RESPONSIBLES_FAIL';
export const CREATE_ORDER_RESPONSIBLES_SUCCESS = 'orders/CREATE_ORDER_RESPONSIBLES_SUCCESS';
export const DELETE_ORDER_RESPONSIBLES_FAIL = 'orders/DELETE_ORDER_RESPONSIBLES_FAIL';
export const DELETE_ORDER_RESPONSIBLES_SUCCESS = 'orders/DELETE_ORDER_RESPONSIBLES_SUCCESS';

export const FETCH_TIMEZONE_SUCCESS = 'orders/FETCH_TIMEZONE_SUCCESS';
export const FETCH_TIMEZONE_FAIL = 'orders/FETCH_TIMEZONE_FAIL';

export const FETCH_ORDER_EXECUTORS_FAIL = 'orders/FETCH_ORDER_EXECUTORS_FAIL';
export const FETCH_ORDER_EXECUTORS_SUCCESS = 'orders/FETCH_ORDER_EXECUTORS_SUCCESS';
export const FETCH_ORDER_EDITORS_FAIL = 'orders/FETCH_ORDER_EDITORS_FAIL';
export const FETCH_ORDER_EDITORS_SUCCESS = 'orders/FETCH_ORDER_EDITORS_SUCCESS';

export const FETCH_DAMAGED_ITEMS = 'orders/FETCH_DAMAGED_ITEMS';
export const FETCH_DAMAGED_ITEMS_FAIL = 'orders/FETCH_DAMAGED_ITEMS_FAIL';
export const FETCH_DAMAGED_ITEMS_SUCCESS = 'orders/FETCH_DAMAGED_ITEMS_SUCCESS';
export const CREATE_DAMAGED_ITEMS_FAIL = 'orders/CREATE_DAMAGED_ITEMS_FAIL';
export const CREATE_DAMAGED_ITEMS_SUCCESS = 'orders/CREATE_DAMAGED_ITEMS_SUCCESS';
export const DELETE_DAMAGED_ITEMS_FAIL = 'orders/DELETE_DAMAGED_ITEMS_FAIL';
export const DELETE_DAMAGED_ITEMS_SUCCESS = 'orders/DELETE_DAMAGED_ITEMS_SUCCESS';
export const UPDATE_DAMAGED_ITEMS_REDUX = 'orders/UPDATE_DAMAGED_ITEMS_REDUX';

export const BLOCK_ORDER_SUCCESS = 'orders/BLOCK_ORDER_SUCCESS';
export const BLOCK_ORDER_FAIL = 'orders/BLOCK_ORDER_FAIL';
export const UNBLOCK_ORDER_SUCCESS = 'orders/UNBLOCK_ORDER_SUCCESS';
export const UNBLOCK_ORDER_FAIL = 'orders/UNBLOCK_ORDER_FAIL';
export const RESET_BLOCK_DATA = 'orders/RESET_BLOCK_DATA';

export const CHANGE_ORDER_SERVICE_SUCCESS = 'orders/CHANGE_ORDER_SERVICE_SUCCESS';
export const CHANGE_ORDER_SERVICE_FAIL = 'orders/CHANGE_ORDER_SERVICE_FAIL';

export const FETCH_ORDER_HISTORY_SUCCESS = 'orders/FETCH_ORDER_HISTORY_SUCCESS';
export const FETCH_ORDER_HISTORY_FAIL = 'orders/FETCH_ORDER_HISTORY_FAIL';
